import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

export default function SharedArticle({ article, onRemove, clickable = false }) {
  const defaultImageUrl = `${window.location.origin}/assets/images/article/default_article_header.jpg`;

  const handleClick = () => {
    if (clickable) {
      window.open(`/article/${article.id}`, '_blank');
    }
  };

  return (
    <Box 
      className={`relative mt-0 p-16 border rounded-8 ${clickable ? 'cursor-pointer hover:bg-gray-50' : ''}`}
      onClick={handleClick}
    >
      {onRemove && (
        <IconButton
          className="absolute z-20 top-0 right-0 m-6 w-32 h-32 min-h-32"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <FuseSvgIcon size={20}>heroicons-solid:x</FuseSvgIcon>
        </IconButton>
      )}
      <div className="aspect-w-16 aspect-h-9 rounded-4 overflow-hidden mb-8">
        <img 
          src={article.headerImageUrl || defaultImageUrl} 
          alt={article.title} 
          className="object-cover"
          onError={(e) => { e.target.src = defaultImageUrl; }}
        />
      </div>
      <Typography variant="h6">{article.title}</Typography>
      <Typography variant="body2" color="textSecondary">{article.summary}</Typography>
    </Box>
  );
}